export default {
  appendStyle(href) {
    const head = document.querySelector('head');
    const styleElement = document.createElement('link');
    styleElement.rel = 'stylesheet';
    styleElement.type = 'text/css';
    styleElement.href = href;
    head.appendChild(styleElement);
  },

  appendFavicon(faviconUrl) {
    const head = document.querySelector('head');
    const favicon = document.createElement('link');
    favicon.setAttribute('test-id', 'custom-favicon');
    favicon.rel = 'icon';
    favicon.type = 'image/ico';
    favicon.href = faviconUrl;
    head.appendChild(favicon);
  },

  removeFavicons() {
    const head = document.querySelector('head');
    const icons = Array.from(head.querySelectorAll('link[rel~=icon]'));
    if (icons.length > 0) {
      icons.forEach(icon => {
        head.removeChild(icon);
      });
    }
  },

  updatePageTitle(title) {
    document.title = title;
  },
};
